export default __webpack_public_path__ + "static/media/D4 - Research_Study.7c6a7ed6.jpg";